import React, { useContext } from 'react'
import { Heading3 } from '@entur/typography'
import { space } from '@entur/tokens'
import { ChoiceChip, ChoiceChipGroup } from '@entur/chip'
import { DisabledContext } from '../../contexts/disable-context'
import { CommentCard } from './comment-card'
import { AllTicketRights } from '../ticket-rights/all-ticket-rights-list'
import { useEmployee } from '../../contexts/employee-context'

export const EmployeeActivities = () => {
  const { disabled } = useContext(DisabledContext)
  const { employee } = useEmployee()
  const [activity, setActivity] = React.useState('Comment')

  return (
    <div>
      <Heading3>Aktivitet</Heading3>
      <span style={{ float: 'left', paddingTop: space.extraSmall2, marginRight: space.small }}>Vis:</span>
      <ChoiceChipGroup
        name="Activity"
        label=""
        onChange={(e) => setActivity((e.target as HTMLInputElement).value)}
        value={activity}
        style={{ marginBottom: space.medium, float: 'left', clear: 'all' }}
        disabled={disabled}
      >
        <ChoiceChip id="show-comment-chip" value="Comment">
          Kommentar
        </ChoiceChip>
        <ChoiceChip data-cy="show-all-ticket-rights-chip" id="show-all-ticket-rights-chip" value="TicketRights">
          Rettigheter
        </ChoiceChip>
      </ChoiceChipGroup>
      <div style={{ clear: 'both' }}>
        {activity === 'Comment' && <CommentCard />}
        {activity === 'TicketRights' && <AllTicketRights ticketRights={employee.ticketRights} />}
      </div>
    </div>
  )
}
